import { ScenarioType, SectorType } from '@/types';

export const filterAreas = [
  { id: 1, name: 'arkansas' },
  { id: 2, name: 'colorado' },
  // { id: 3, name: 'dolores' },
  { id: 4, name: 'gunnison' },
  { id: 5, name: 'metro' },
  { id: 6, name: 'northPlatte' },
  { id: 7, name: 'republican' },
  { id: 8, name: 'rioGrande' },
  // { id: 9, name: 'sanJuan' },
  { id: 10, name: 'southPlatte' },
  { id: 11, name: 'southwest' },
  { id: 12, name: 'all' },
  { id: 13, name: 'white' },
  { id: 14, name: 'yampa' },
];

export const filterScenarios: ScenarioType[] = [
  { id: 'Baseline', name: 'Baseline (2015)', order: 1 },
  { id: 'Business as Usual', name: 'A: Business as Usual', order: 2 },
  { id: 'Weak Economy', name: 'B: Weak Economy', order: 3 },
  { id: 'Cooperative Growth', name: 'C: Cooperative Growth', order: 4 },
  { id: 'Adaptive Innovation', name: 'D: Adaptive Innovation', order: 5 },
  { id: 'Hot Growth', name: 'E: Hot Growth', order: 6 },
];

export const filterSectors: SectorType[] = [
  { id: 0, key: 'summary', name: 'Summary / Overview' },
  { id: 1, key: 'municipalIndustrial', name: 'Municipal & Industrial' },
  { id: 2, key: 'agricultural', name: 'Agricultural' },
  { id: 3, key: 'environRec', name: 'Environmental & Recreational' },
];
